import { useAtomValue } from 'jotai';
import * as analysisState from '@/components/Analysis/state';
import { PointOfInterest, useAllPointOfInterestsForDataLoaderQuery } from '@/__generated__/graphql';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { useGroupBy } from '@/hooks';

export const useGroupedPois = () => {
  const structureId = useGetStructureId();
  const selectedAssemblyId = useAtomValue(analysisState.selectedAssemblyId);
  const { data, loading } = useAllPointOfInterestsForDataLoaderQuery({
    variables: {
      input: {
        structureId,
        assemblyIds: [selectedAssemblyId ?? ''],
      },
    },
  });

  const groupedPois = useGroupBy<PointOfInterest>(
    (data?.pointOfInterests as PointOfInterest[]) ?? [],
    'templateId'
  );

  return { groupedPois, loading };
};
